"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAndPopulateItems = void 0;
var job_1 = __importDefault(require("@common/model/job"));
var apiService_1 = __importDefault(require("@common/services/apiService"));
var util_1 = require("@features/ItemCommon/service/util");
var groupJobsByRemoteId_1 = require("@features/QueuePage/util/groupJobsByRemoteId");
var fetchAndPopulateItem_1 = require("./fetchAndPopulateItem");
function fetchAndPopulateItems(domain, limit, state, decisionSet, feedbackSetArray, isPreApproved, currentQueueName) {
    return __awaiter(this, void 0, void 0, function () {
        var itemsResults, items, itemsWithDecision, group, isValidFeedbackArray, promises, allJobDetailsPromises;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiService_1.default.getProcessAds({ domain: domain }, { limit: limit, state: state })];
                case 1:
                    itemsResults = _a.sent();
                    items = itemsResults.data.results;
                    itemsWithDecision = getItemsWithDecision(items, decisionSet, isPreApproved);
                    group = (0, groupJobsByRemoteId_1.groupJobsByRemoteId)(itemsWithDecision);
                    isValidFeedbackArray = Array.isArray(feedbackSetArray) && feedbackSetArray.length > 0;
                    if (isValidFeedbackArray) {
                        (group || []).forEach(function (jobGroup) {
                            var job = jobGroup.jobs[0];
                            job.selectedFeedback = (0, util_1.getFeedbackIdsForJob)(job, feedbackSetArray);
                        });
                    }
                    promises = group.map(function (_a) {
                        var _b = __read(_a.jobs, 1), job = _b[0];
                        return (0, fetchAndPopulateItem_1.populateJobDetails)(domain, job, currentQueueName);
                    });
                    allJobDetailsPromises = Promise.all(promises);
                    return [2 /*return*/, { items: itemsWithDecision, itemsGroup: group, allJobDetailsPromises: allJobDetailsPromises }];
            }
        });
    });
}
exports.fetchAndPopulateItems = fetchAndPopulateItems;
function getItemsWithDecision(itemsResults, decisionSet, isPreApproved) {
    return itemsResults.map(function (item) {
        var job = new job_1.default();
        job.setDataWithJobAndDecision(item, decisionSet, isPreApproved);
        job.shouldDeferLoadingImages = true;
        return job;
    });
}
